<template>
  <v-sheet class="caption px-4 py-2" :class="colors" rounded>
    <v-row no-gutters class="align-center ma-n1">
      <v-col cols="auto" class="pa-1">
        <c-item
          v-if="enables.airport"
          icon="flight_takeoff" caption="空港近郊"
        />
      </v-col>
      <v-col cols="auto" v-if="enables.airport">
        <span v-text="iconspace"></span>
      </v-col>
      <v-col cols="auto" class="pa-1">
        <c-item
          v-if="enables.station"
          icon="directions_transit_filled" caption="駅近"
        />
      </v-col>
      <v-col cols="auto" v-if="enables.station">
        <span v-text="iconspace"></span>
      </v-col>
      <v-col cols="auto" class="pa-1">
        <c-item
          v-if="enables.keykey"
          icon="local_convenience_store" caption="24時間貸出対応"
        />
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import CItem from './CItem'

export default {
  name: 'CStationsLegend',
  components: {
    CItem
  },
  props: {
    enables: {
      type: Object,
      required: true
    }
  },
  computed: {
    colors () {
      const dark = this.$vuetify.theme.dark
      return dark ? ['grey', 'darken-4'] : ['grey', 'lighten-4']
    },
    iconspace () {
      return '　'
    }
  }
}
</script>
